__turbopack_context__.v({
  "container": "_5gx9-G_container",
  "videoContainer": "_5gx9-G_videoContainer",
  "videoIframe": "_5gx9-G_videoIframe",
});
